<template>
<div class="container">

  <h2 class="is-clearfix is-size-3">
    <template v-if="isLoading">
      <span class="is-flex is-justify-content-space-between is-align-items-center">
        <span class="is-block">
          <b-skeleton height="1.5rem" width="14rem" />
        </span>
        <span class="small">
          <b-skeleton height="1rem" width="8rem" />
        </span>
      </span>
    </template>
    <template v-else>
      <b-icon icon="check-circle" v-if="data.solved" />
      <b-icon icon="times-circle" v-if="data.givenup" />
      {{data.name}}
      <span class="text-muted">({{data.points}} points)</span>
      <span class="small is-pulled-right">{{data.tags}}</span>
    </template>
  </h2>

  <div :class="rhsComponents.length ? 'columns is-clearfix' :''">
    <div :class='rhsComponents.length ? "column is-two-thirds" : ""'>
  <div class="card mt-2">
    <header class="card-header">
      <p class="card-header-title">
        <b-icon icon="align-justify" />
        Description
      </p>
      <span class="card-header-icon" aria-label="more options" v-if="isLoading">
        <b-icon icon="clock"/>
        <b-skeleton height="1rem" width="10rem" />
      </span>
      <span class="card-header-icon" aria-label="more options" v-else-if="data.submission_ending_time">
        <b-icon icon="clock"/>
        {{ new Date(data.submission_ending_time) }}
      </span>
    </header>
    <div class="card-content">
      <div class="content" v-if="isLoading">
        <b-skeleton height="1rem" width="90%" />
        <b-skeleton height="1rem" width="95%" />
        <b-skeleton height="1rem" width="80%" />
        <b-skeleton height="1rem" width="60%" />
      </div>
      <div class="content" v-else>
        <div v-html="data.description" v-if="!data.markdown"></div>
        <div v-html="markdownDescription" v-else></div>
      </div>
    </div>
  </div>
    </div>

    <div class="column" v-if="rhsComponents">
      <component v-for="(cmp,i) in rhsComponents" :key="i" :is="cmp"/>
    </div>
  </div>

  <template v-if="!isLoading">
    <div class="box has-text-centered mt-5 pl-6 pr-6 ml-6 mr-6" v-if="(new Date()) < (new Date(data.submission_starting_time))">
     Flag submission will be enabled on {{ new Date(data.submission_starting_time) }}
    </div>
    <div v-else-if="!data.solved && !data.givenup" class="mt-5 pl-6 pr-6 ml-6 mr-6">
      <b-field label="Flag" label-position="on-border" grouped>
        <b-input ref="flag" type="text" v-model='flag' placeholder="Flag" v-on:keyup.native.enter="submit" expanded></b-input>
        <b-button type="is-primary" icon-left="check-circle" @click="submit">Submit</b-button>
        <b-button class="ml-3 is-pulled-right" icon-left="times-circle" type="is-danger" @click="giveup" v-if="(new Date()) < (new Date(data.submission_ending_time))">Give Up</b-button>
      </b-field>

    </div>
    <div v-else>
      <component v-for="(cmp,i) in bottomComponents" :key="i" :is="cmp"/>
    </div>
  </template>
</div>
</template>

<script>
import marked from 'marked';

export default {
  data() {
    return {
      name: this.$route.params.challenge_name,
      flag: '',
      data: {},
      isLoading: true,
    };
  },
  methods: {
    async submit() {
      try {
        const res = await this.$ctforge.api.post('/challenges/submit', {
          flag: this.flag,
          name: this.name,
        });
        this.notify(res.message);
        this.updateView();
        this.$root.$emit('update-challenge');
      } catch (e) {
        this.notify(e.message, 'is-danger');
      }
    },
    async giveup() {
      this.$buefy.dialog.prompt({
        title: 'Give Up',
        message: `<div class="content">Type "<b>GIVE UP ${this.name}</b>" to confirm.<br><b>This action cannot be undone:</b><ul><li>You will no longer be able to submit a flag for this challenge</li><li>You will only get a fraction of the points for this challenge in the recap questions</li></ul></div>`,
        confirmText: 'Give Up',
        cancelText: 'Cancel',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async (value) => {
          if (value !== `GIVE UP ${this.name}`) {
            this.notify('Confirmation text does not match', 'is-danger');
            return;
          }
          try {
            const res = await this.$ctforge.api.post('/challenges/submit', {
              giveup: true,
              name: this.name,
            });
            this.notify(res.message);
            this.updateView();
            this.$root.$emit('update-challenge');
          } catch (e) {
            this.notify(e.message, 'is-danger');
          }
        },
      });
    },
    async updateView() {
      this.isLoading = true;
      try {
        this.data = await this.$ctforge.api.get(`/challenges/${this.name}`);
      } catch (e) {
        this.notify(e.message, 'is-danger');
        this.$router.replace('/');
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    markdownDescription() {
      return marked(this.data.description);
    },
    rhsComponents() {
      return this.$ctforge.findComponents(
        (labels) => labels.type === 'challenge' && labels.position === 'right',
      );
    },
    bottomComponents() {
      return this.$ctforge.findComponents(
        (labels) => labels.type === 'challenge' && labels.position === 'bottom',
      );
    },
  },
  async mounted() {
    await this.updateView();
    document.title = `Challenges - ${this.name}`;
  },
};
</script>

<style>
  .is-clearfix {
    clear: both;
  }

</style>
